<template>
  <div class="cgs-app-worksheet">
    <div class="cgs-worksheet-header">
      <van-nav-bar :border="false" :title="worksheetName">
        <template #left>
          <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
        </template>
        <template #right>
          <van-popover
            v-model="showMoreTool"
            trigger="click"
            placement="bottom-end"
            :actions="actions"
            @select="selectedMore"
          >
            <template #reference>
              <span class="iconfont cgsIcon-gengduocaozuo"></span>
            </template>
          </van-popover>
        </template>
      </van-nav-bar>
    </div>
    <div class="cgs-worksheet-content">
      <cgs-app-form
        v-if="worksheetType === 0"
        :worksheetDetail="worksheetDetail"
      ></cgs-app-form>
      <custom-page
        v-else-if="worksheetType === 1"
        :worksheetDetail="worksheetDetail"
      ></custom-page>
      <!-- <van-tabs v-model="active" title-active-color='rgba(33,150,243,1)' :swipeable="true" :animated="true" :lazy-render="true">
                <van-tab title="全部">内容 1</van-tab>
            </van-tabs> -->
    </div>
  </div>
</template>

<script>
import { NavBar, Tab, Tabs, PullRefresh, Popover } from "vant";
import customPage from "./customPage/index";
import appForm from "./formView.vue";
import { getWorksheetInfo,addShortcut,getShortcut,delShortcut } from "@/api/application";
import { getUserAuthority } from "@/util/author";

export default {
  components: {
    vanNavBar: NavBar,
    vanTab: Tab,
    vanTabs: Tabs,
    vanPopover: Popover,
    customPage,
    cgsAppForm: appForm,
  },
  data() {
    return {
      wholeLoading: false,
      active: 0,
      showMoreTool: false,
      worksheetDetail: {},
      worksheetType: 0,
      worksheetName: "",
      manageable: false,
      fastEntryAuthor: false,
      actions: [{ text: "设置工作表", id: "edit" },{ text: "设置快捷入口", id: "add" }],
    };
  },
  created() {
    this.setRowAuth()
    this.init();
    this.compareShortcut()
  },
  computed: {
    userId: {
      get() {
        let userAuthority = getUserAuthority();
        return userAuthority.userId;
      },
      set() {},
    },
    worksheetId: {
      get() {
        return this.$route.params.worksheetId;
      },
      set() {},
    },
  },
  methods: {
    async init() {
      this.wholeLoading = true;
      try {
        let result = await getWorksheetInfo(this.worksheetId);
        this.worksheetDetail = result.data;
        this.worksheetType = this.worksheetDetail.type;
        this.worksheetName = this.worksheetDetail.name;
        if(this.worksheetDetail.owner === this.userId){
            this.manageable = true
        }
        if (this.pageType === 1 && "config" in this.worksheetDetail) {
          this.worksheetDetail.config =
            this.worksheetDetail.config === ""
              ? []
              : JSON.parse(this.worksheetDetail.config);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.wholeLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async selectedMore(action) {
      switch (action.id) {
        case "edit":
          if (this.manageable) {
            this.$router.push({ path: `/editWorksheet/${this.worksheetId}` });
          } else {
            this.$Notify({ type: "danger", message: "没有权限,请联系相关人员" });
          }
          break;
        case "add":
          if (this.fastEntryAuthor) {
            let a = 'LIST';
            let result = await addShortcut({
                sheetId: this.$route.params.worksheetId,
                url: this.$route.path,
                linkType: a,
            })
            if (result) {
                this.$Notify({ type: "success", message: "设置成功" });
                this.goBack();
            } else {
                this.$Notify({ type: "danger", message: "设置失败" });
            }
          }else{
            this.$Notify({ type: "danger", message: "没有权限,请联系相关人员" });
          }
            break;
        case "del":
          if (this.fastEntryAuthor) {
            let d = 'LIST'
            let res = await delShortcut({
                sheetId: this.$route.params.worksheetId,
                url: this.$route.path,
                linkType: d,
            })
            if (res) {
                this.$Notify({ type: "success", message: "取消成功" });
                this.goBack();
            } else {
                this.$Notify({ type: "danger", message: "取消失败" });
            }  
          }else{
            this.$Notify({ type: "danger", message: "没有权限,请联系相关人员" });
          }
      }
    },
    setRowAuth() {
      let appAuth = getUserAuthority()
      if (appAuth && appAuth.operatingAuthorities) {
        let _operAuth = appAuth.operatingAuthorities
        if (_operAuth.includes("MANAGE_BACKEND")) {
          this.fastEntryAuthor = true;
        }
      }
    },
    async compareShortcut(){
        let ShortcutList = await getShortcut()
        let list = ShortcutList.data
        list.forEach(data => {
            let url = data.url;
            if( this.$route.path === url){
                this.actions[1].text = "取消快捷入口"
                this.actions[1].id = "del"
            }
        });
    }
  },
};
</script>

<style scoped>
.cgs-app-worksheet {
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}
.cgs-worksheet-header {
  /* color: #fff; */
}
.cgs-worksheet-content {
  flex: 1;
  overflow: auto;
}
</style>